module.exports = __webpack_public_path__ + "static/media/pl.ef2c1261.svg";